import { render, staticRenderFns } from "./navbar-component.vue?vue&type=template&id=f504bd38&scoped=true"
import script from "./navbar-component.vue?vue&type=script&lang=ts&setup=true"
export * from "./navbar-component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./navbar-component.vue?vue&type=style&index=0&id=f504bd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f504bd38",
  null
  
)

export default component.exports